import React, {useContext, useEffect} from 'react';
//import { withRouter } from "react-router";
import {Header, Image} from "semantic-ui-react";
import {config} from "./../../../Config";
import "./SelfCheckinHeader.css";



const SelfCheckinHeader = (props) => {
  return (
    <header className="header-container">
      <Image src={`${config.url.URL_MB}/sources/customer_area/logo-selfcheckin.png`} size='tiny' />
      <div className="title-container">
        <h1>{`${props.infosEstablishment.name} ${props.translations.welcomesYou} !`}</h1>
      </div>

      <div className="header-infos">
        <p>{props.translations.selfCheckinBasicInfos}</p>
      </div>
    </header>
  );
}

export default SelfCheckinHeader;